import SideMenu from './Index.vue'

SideMenu.install = function(Vue) {
    Vue.component(SideMenu.name, SideMenu)
}

export default SideMenu
